import { useSelector } from "react-redux";
import { CheckBoxOptionalGroup } from "modules/connectors/components/OptionalGroup";
import { useTranslation} from 'react-i18next';
import { connectorsettings as i18nNamespace} from "../../../../i18n/namespace";

const infoText = (t) => {
    return { autoOntapUpgrade: t("auto_ontap_upgrade"),}
}

const OntapUpdateTitle = () => {
    const configValue = useSelector(state => state.connectorSettings.settings.config.autoOntapUpgrade);
    const { t } = useTranslation(i18nNamespace);
    return {
        title: t("automatic_cvo_update"),
        value: configValue ? t("on") : t("off"),
        tooltip: infoText(t).autoOntapUpgrade
    }
}

const OntapUpdateContent = ({ close: closeOptionalGroup }) => {
    const { t } = useTranslation(i18nNamespace);
    return <CheckBoxOptionalGroup closeOptionalGroup={closeOptionalGroup} configKey='autoOntapUpgrade'
                                  text= {t("automatically_update_cvo")}/>
};

export const OntapUpdate = {
    Title: OntapUpdateTitle,
    Content: OntapUpdateContent
}


